var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "painel-secao-progresso d-flex flex-column az-gap-small",
      class: { "painel-secao-progresso--compacto": _vm.compacto },
      attrs: { "data-test": "painel-secao-progresso" }
    },
    [
      !_vm.semTitulo
        ? _c(
            "h3",
            {
              staticClass:
                "az-text-primary az-size-14 font-weight-medium ma-0 mb-1"
            },
            [_vm._v(_vm._s(_vm.titulo))]
          )
        : _vm._e(),
      _c("transition", { attrs: { name: _vm.nomeDaTransicao } }, [
        _vm.janela.concluidasOcultas
          ? _c(
              "p",
              {
                staticClass:
                  "painel-secao-progresso__ocultas d-flex align-center az-gap-xxsmall ia-sidebar-aux ma-0",
                attrs: { "data-test": "painel-secao-progresso-ocultas" }
              },
              [
                _c("icon-svg", {
                  attrs: {
                    name: _vm.ICONE_DE_CONCLUIDAS_OCULTAS,
                    size: _vm.TAMANHO_DO_ICONE_DAS_OCULTAS,
                    color: "var(--neutral-600)"
                  }
                }),
                _vm._v(" " + _vm._s(_vm.textoDasOcultas) + " ")
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "transition-group",
        {
          tag: "ol",
          staticClass: "painel-secao-progresso__lista pa-0 ma-0",
          attrs: { name: _vm.nomeDaTransicao }
        },
        _vm._l(_vm.linhas, function(linha) {
          return _c(
            "li",
            {
              key: linha.id,
              staticClass:
                "painel-secao-progresso__passo d-flex align-start az-gap-small",
              attrs: {
                "aria-current": linha.ariaCurrent,
                "data-test": "painel-secao-progresso-passo"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "painel-secao-progresso__marcador d-inline-flex align-center justify-center flex-shrink-0",
                  attrs: {
                    role: "img",
                    "aria-label": linha.rotuloDoStatus,
                    title: linha.rotuloDoStatus,
                    "data-test": "painel-secao-progresso-marcador"
                  }
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "painel-marcador", mode: "out-in" } },
                    [
                      linha.emAndamento
                        ? _c("v-progress-circular", {
                            key: linha.status,
                            staticClass: "painel-secao-progresso__spinner",
                            attrs: {
                              indeterminate: "",
                              size: _vm.tamanhoDoMarcador,
                              width: 1.5,
                              color: "primary"
                            }
                          })
                        : linha.concluida
                        ? _c("icon-svg", {
                            key: linha.status,
                            staticClass: "painel-secao-progresso__check",
                            attrs: {
                              name: _vm.ICONE_DE_CONCLUIDO,
                              size: _vm.tamanhoDoMarcador,
                              color: "primary"
                            }
                          })
                        : linha.falhou
                        ? _c("icon-svg", {
                            key: linha.status,
                            attrs: {
                              name: _vm.ICONE_DE_FALHA,
                              size: _vm.tamanhoDoMarcador,
                              color: "danger"
                            }
                          })
                        : linha.corrente
                        ? _c("span", {
                            key: linha.status,
                            staticClass: "painel-secao-progresso__corrente"
                          })
                        : _c("span", {
                            key: linha.status,
                            staticClass: "painel-secao-progresso__pendente"
                          })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass:
                    "painel-secao-progresso__texto d-flex flex-column",
                  class: [
                    {
                      "painel-secao-progresso__texto--pendente": linha.pendente
                    },
                    _vm.classeDoPasso
                  ]
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "painel-secao-progresso__titulo az-text-primary",
                      class: _vm.classeDoPasso,
                      attrs: { "data-test": "painel-secao-progresso-titulo" }
                    },
                    [_vm._v(_vm._s(linha.titulo))]
                  ),
                  linha.detalhe
                    ? _c(
                        "span",
                        {
                          staticClass: "ia-sidebar-aux",
                          class: {
                            "painel-secao-progresso__detalhe--falhou":
                              linha.falhou
                          },
                          attrs: {
                            "data-test": "painel-secao-progresso-detalhe"
                          }
                        },
                        [_vm._v(_vm._s(linha.detalhe))]
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }